module.exports = __webpack_public_path__ + "static/media/sapp2.301e4cbd.png";